import React, {useState, useEffect} from 'react';
import {motion, AnimatePresence} from 'framer-motion';
import './WhoComponent.css';

const WhoComponent: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const narrativeFlow = [
    {role: "Product Managers", story: "orchestrating vision into reality"},
    {role: "Legal Teams", story: "ensuring clarity in decisions that matter"},
    {role: "Developers", story: "transforming complexity into clarity"},
    {role: "Analysts", story: "turning raw data into insight"},
    {role: "Entrepreneurs ", story: "structuring chaos into momentum"},
    {role: "Researchers", story: "discovering patterns in the unknown"},
    {role: "Design Leaders", story: "crafting experiences that flow"},
    {role: "Strategic Thinkers", story: "connecting dots others miss"},
    {role: "Consultants", story: "capturing decisions across clients without losing context"},
    {role: "Healthcare Professionals", story: " Connecting trial protocols, literature, patient data summaries."}

  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % narrativeFlow.length);
    }, 3500);

    return () => clearInterval(interval);
  }, [narrativeFlow.length]);

  const current = narrativeFlow[currentIndex];

  return (
      <motion.div
          className="story-bridge"
          initial={{opacity: 0, y: 20}}
          whileInView={{opacity: 1, y: 0}}
          transition={{
            duration: 0.8,
            delay: 0.2,
            ease: [0.25, 0.1, 0.25, 1]
          }}
          viewport={{once: true}}
      >
        <div className="story-glass-container">
          <div className="story-backdrop"></div>
          <div className="story-glow"></div>

          <div className="story-content">
            <motion.div
                className="story-prelude"
                initial={{opacity: 0, y: 10}}
                whileInView={{opacity: 1, y: 0}}
                transition={{duration: 0.6, delay: 0.4}}
                viewport={{once: true}}
            >
              {/*Every day, brilliant minds lose focus to shallow tools.*/}
            </motion.div>

            <div className="story-narrative">
              <motion.span className="story-static">We built this for</motion.span>
              <div className="story-dynamic-container">
                <AnimatePresence mode="wait">
                  <motion.div
                      key={currentIndex}
                      className="story-dynamic"
                      initial={{opacity: 0, y: 15, rotateX: -15}}
                      animate={{opacity: 1, y: 0, rotateX: 0}}
                      exit={{opacity: 0, y: -15, rotateX: 15}}
                      transition={{
                        duration: 0.6,
                        ease: [0.4, 0, 0.2, 1]
                      }}
                  >
                    <span className="story-role">{current.role}</span>
                    <span className="story-separator">—</span>
                    <span className="story-action">{current.story}</span>
                  </motion.div>
                </AnimatePresence>
              </div>
            </div>

            <motion.div
                className="story-conclusion"
                initial={{opacity: 0}}
                whileInView={{opacity: 1}}
                transition={{duration: 0.8, delay: 0.8}}
                viewport={{once: true}}
            >
              {/*in a world that deserves <span className="story-highlight">deeper thinking</span>.*/}
            </motion.div>

            <motion.div
                className="story-connector"
                initial={{scaleY: 0}}
                whileInView={{scaleY: 1}}
                transition={{duration: 1.4, delay: 1.0, ease: [0.25, 0.1, 0.25, 1]}}
                viewport={{once: true}}
            />
          </div>
        </div>
      </motion.div>
  );
};

export default WhoComponent;